import { Dispatch, SetStateAction, useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import { Modal, Button } from "@mui/material";
import { showError, showToast } from "../constants/toasts";
import {
  useAddTagGroupsMutation,
  useUpdateTagGroupMutation,
} from "../service/group&tags";

interface AddCategoryModalProps {
  open: boolean;
  onClose: () => void;
  setOpen: Dispatch<SetStateAction<boolean>>;
  selectedGroupId: string;
  selectedGroup: any;
  getGroupApi: () => void;
}

export default function AddTagGroup({
  open,
  onClose,
  setOpen,
  getGroupApi,
  selectedGroupId,
  selectedGroup,
}: AddCategoryModalProps) {
  const [addTagGroup] = useAddTagGroupsMutation();
  const [updateTagGroup] = useUpdateTagGroupMutation();

  const [name, setName] = useState("");
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleAddTagGroup = async () => {
    setError(true);
    if (name.trim() === "") {
      showError("Name is required");
      return;
    }

    setLoading(true);
    try {
      const body = {
        name,
        ...(selectedGroupId ? { groupTagId: selectedGroupId } : {}),
      };

      let response;
      if (selectedGroupId) {
        response = await updateTagGroup(body).unwrap();
      } else {
        response = await addTagGroup(body).unwrap();
      }
      if (response?.status === 200) {
        setError(false);
        setOpen(false);
        showToast(
          selectedGroupId
            ? "Group updated successfully"
            : "Group added successfully"
        );
        getGroupApi();
      } else {
        showError(response?.message || "");
      }
    } catch (error: any) {
      showError(error?.data?.message || "");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (open && selectedGroup) {
      setName(selectedGroup?.name || "");
    } else if (open && !selectedGroup) {
      setName("");
    }
  }, [open, selectedGroup]);

  return (
    <Modal className="modal addCategory_modal" open={open} onClose={onClose}>
      <div className="modal-dialog">
        <div className="modal-body">
          <div className="modal_title text_center mb_30">
            <h2>Add Group</h2>
            <div
              role="button"
              tabIndex={0}
              className="btn-close"
              onClick={() => setOpen(false)}
            >
              <CloseIcon />
            </div>
          </div>
          <div className="control_group">
            <label htmlFor="group">Group Name</label>
            <TextField
              id="group"
              placeholder="Enter Group Name"
              fullWidth
              hiddenLabel
              value={name}
              inputProps={{ maxLength: 40 }}
              onChange={(e) => {
                if (e.target.value === " " || e.target.value === ".") {
                } else {
                  setName(e.target.value);
                }
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                  handleAddTagGroup();
                }
              }}
            />
            {error && name == "" ? (
              <h6 className="err_msg">Name is required</h6>
            ) : (
              ""
            )}
          </div>
          <div className="footer_btn_flex">
            <Button className="btn btn_primary" onClick={handleAddTagGroup}>
              Submit
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
}
